(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["belyr-beauty-home"] && !Shopify.designMode) return;
  try {
    
  const initializeBelyrPackageOffers = () => {
    document.querySelectorAll('[data-bh-package-offers]').forEach((root) => {
      if (root.dataset.packageOffersInitialized === 'true') return;
      root.dataset.packageOffersInitialized = 'true';

      const status = root.querySelector('[data-bh-package-status]');
      const buttons = Array.from(root.querySelectorAll('[data-bh-package-add]'));
      const routesRoot = window.Shopify?.routes?.root || '/';

      buttons.forEach((button) => {
        button.addEventListener('click', async () => {
          const variantIds = (button.dataset.variantIds || '')
            .split(',')
            .map((id) => id.trim())
            .filter(Boolean);

          if (!variantIds.length || button.dataset.canAdd !== 'true') return;

          buttons.forEach((item) => {
            item.disabled = true;
          });
          button.classList.add('is-loading');
          if (status) status.textContent = `Lägger ${button.dataset.packageName} i varukorgen…`;

          try {
            const response = await fetch(`${routesRoot}cart/add.js`, {
              method: 'POST',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                items: variantIds.map((id) => ({ id: Number(id), quantity: 1 }))
              })
            });

            if (!response.ok) {
              const error = await response.json().catch(() => ({}));
              throw new Error(error.description || 'Paketet kunde inte läggas i varukorgen.');
            }

            const discountCode = button.dataset.discountCode;
            const cartPath = `${routesRoot}cart`;

            if (discountCode) {
              window.location.assign(`${routesRoot}discount/${encodeURIComponent(discountCode)}?redirect=${encodeURIComponent(cartPath)}`);
            } else {
              window.location.assign(cartPath);
            }
          } catch (error) {
            if (status) status.textContent = error.message || 'Paketet kunde inte läggas i varukorgen. Försök igen.';
            button.classList.remove('is-loading');
            buttons.forEach((item) => {
              item.disabled = item.dataset.canAdd !== 'true';
            });
          }
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeBelyrPackageOffers, { once: true });
  } else {
    initializeBelyrPackageOffers();
  }

  document.addEventListener('shopify:section:load', initializeBelyrPackageOffers);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["belyr-caia-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobileTabs = Array.from(document.querySelectorAll('.belyr-caia-footer__mobile-tab'));

    mobileTabs.forEach((tab) => {
      tab.open = false;
      tab.addEventListener('toggle', () => {
        if (!tab.open) return;

        mobileTabs.forEach((otherTab) => {
          if (otherTab !== tab) otherTab.open = false;
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["belyr-product-page"] && !Shopify.designMode) return;
  try {
    
  const initializeBelyrProductPages = () => {
    document.querySelectorAll('[data-belyr-pdp]').forEach((root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const mainImage = root.querySelector('[data-belyr-main-image]');
      const thumbnails = root.querySelectorAll('[data-belyr-thumb]');

      thumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener('click', () => {
          if (!mainImage) return;
          mainImage.removeAttribute('srcset');
          mainImage.src = thumbnail.dataset.src;
          mainImage.alt = thumbnail.dataset.alt || '';
          mainImage.classList.toggle('belyr-pdp__main-image--packshot', thumbnail.dataset.belyrPackshot === 'true');
          thumbnails.forEach((item) => {
            item.classList.remove('is-active');
            item.setAttribute('aria-pressed', 'false');
          });
          thumbnail.classList.add('is-active');
          thumbnail.setAttribute('aria-pressed', 'true');
        });
      });

      const source = root.querySelector('[data-belyr-description-source]');
      const intro = root.querySelector('[data-belyr-intro]');
      const accordions = root.querySelector('[data-belyr-accordions]');

      if (!source || !intro || !accordions) return;

      const children = Array.from(source.children);
      const groups = [];
      let currentGroup = null;
      let propertiesGroup = null;

      children.forEach((child) => {
        if (child.tagName === 'H2') return;

        if (child.tagName === 'H3') {
          const heading = child.textContent.trim();
          const normalized = heading.toLocaleLowerCase('sv-SE');

          if (normalized.includes('passar dig') || normalized.includes('resultatet') || normalized === 'känslan' || normalized.includes('känslan på')) {
            if (!propertiesGroup) {
              propertiesGroup = { heading: 'Egenskaper', nodes: [] };
              groups.push(propertiesGroup);
            }
            const subheading = document.createElement('h4');
            subheading.textContent = heading;
            propertiesGroup.nodes.push(subheading);
            currentGroup = propertiesGroup;
            return;
          }

          const displayHeading = normalized.includes('så använder') ? 'Gör så här' : heading;
          currentGroup = { heading: displayHeading, nodes: [] };
          groups.push(currentGroup);
          return;
        }

        if (!currentGroup && child.tagName === 'P') {
          intro.appendChild(child.cloneNode(true));
          return;
        }

        if (currentGroup) currentGroup.nodes.push(child.cloneNode(true));
      });

      const shippingDetails = accordions.querySelector('details');

      groups.forEach((group) => {
        if (!group.nodes.length) return;
        const details = document.createElement('details');
        const summary = document.createElement('summary');
        const label = document.createElement('span');
        const icon = document.createElement('span');
        const content = document.createElement('div');

        label.textContent = group.heading;
        icon.className = 'belyr-pdp__summary-icon';
        icon.setAttribute('aria-hidden', 'true');
        content.className = 'belyr-pdp__accordion-content';
        group.nodes.forEach((node) => content.appendChild(node));
        summary.append(label, icon);
        details.append(summary, content);
        accordions.insertBefore(details, shippingDetails);
      });

      const readMore = root.querySelector('[data-belyr-read-more]');
      if (readMore) {
        readMore.addEventListener('click', () => {
          const firstDetails = accordions.querySelector('details');
          if (!firstDetails) return;
          firstDetails.open = true;
          firstDetails.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }

      const recommendationRoot = root.querySelector('[data-belyr-recommendations]');
      const recommendationTrack = root.querySelector('[data-belyr-recommendation-track]');
      const recommendationPrevious = root.querySelector('[data-belyr-recommendation-previous]');
      const recommendationNext = root.querySelector('[data-belyr-recommendation-next]');
      const recommendationProgress = root.querySelector('[data-belyr-recommendation-progress]');

      if (recommendationRoot && recommendationTrack && recommendationPrevious && recommendationNext && recommendationProgress) {
        const updateRecommendations = () => {
          const maximum = Math.max(recommendationTrack.scrollWidth - recommendationTrack.clientWidth, 0);
          const position = Math.min(Math.max(recommendationTrack.scrollLeft, 0), maximum);
          const visibleRatio = Math.min(recommendationTrack.clientWidth / recommendationTrack.scrollWidth, 1);
          const progressTravel = visibleRatio > 0 ? ((1 - visibleRatio) / visibleRatio) * 100 : 0;
          const progressPosition = maximum > 0 ? (position / maximum) * progressTravel : 0;

          recommendationPrevious.disabled = position <= 2;
          recommendationNext.disabled = position >= maximum - 2;
          recommendationProgress.style.width = `${visibleRatio * 100}%`;
          recommendationProgress.style.transform = `translateX(${progressPosition}%)`;
        };

        const scrollRecommendations = (direction) => {
          const card = recommendationTrack.querySelector('.belyr-pdp-card');
          const step = card ? card.getBoundingClientRect().width + 14 : recommendationTrack.clientWidth * 0.8;
          recommendationTrack.scrollBy({ left: step * direction, behavior: 'smooth' });
        };

        recommendationPrevious.addEventListener('click', () => scrollRecommendations(-1));
        recommendationNext.addEventListener('click', () => scrollRecommendations(1));
        recommendationTrack.addEventListener('scroll', () => window.requestAnimationFrame(updateRecommendations), { passive: true });
        window.addEventListener('resize', updateRecommendations, { passive: true });
        updateRecommendations();
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeBelyrProductPages, { once: true });
  } else {
    initializeBelyrProductPages();
  }

  document.addEventListener('shopify:section:load', initializeBelyrProductPages);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["belyr-routine-page"] && !Shopify.designMode) return;
  try {
    
  const initBelyrSerumCarousels = (root = document) => {
    root.querySelectorAll('[data-brp-serum-carousel]').forEach((carousel) => {
      if (carousel.dataset.brpSerumReady === 'true') return;

      const track = carousel.querySelector('[data-brp-serum-track]');
      const previous = carousel.querySelector('[data-brp-serum-prev]');
      const next = carousel.querySelector('[data-brp-serum-next]');
      const current = carousel.querySelector('[data-brp-serum-current]');
      const total = carousel.querySelector('[data-brp-serum-total]');
      const cards = track ? Array.from(track.children) : [];

      if (!track || !previous || !next || cards.length === 0) return;

      carousel.dataset.brpSerumReady = 'true';
      total.textContent = String(cards.length);

      const activeIndex = () => {
        const trackLeft = track.getBoundingClientRect().left;
        let closestIndex = 0;
        let closestDistance = Number.POSITIVE_INFINITY;

        cards.forEach((card, index) => {
          const distance = Math.abs(card.getBoundingClientRect().left - trackLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        return closestIndex;
      };

      const update = () => {
        const index = activeIndex();
        current.textContent = String(index + 1);
        previous.disabled = index === 0;
        next.disabled = index === cards.length - 1;
      };

      const moveTo = (index) => {
        const target = cards[Math.max(0, Math.min(index, cards.length - 1))];
        track.scrollTo({
          left: target.offsetLeft - track.offsetLeft,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      };

      previous.addEventListener('click', () => moveTo(activeIndex() - 1));
      next.addEventListener('click', () => moveTo(activeIndex() + 1));

      let frame;
      track.addEventListener('scroll', () => {
        window.cancelAnimationFrame(frame);
        frame = window.requestAnimationFrame(update);
      }, { passive: true });

      if ('ResizeObserver' in window) {
        new ResizeObserver(update).observe(track);
      }

      update();
    });
  };

  initBelyrSerumCarousels();
  document.addEventListener('shopify:section:load', (event) => initBelyrSerumCarousels(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["belyr-storefront-polish"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.belyrCartLinkBridgeInitialized) return;
    window.belyrCartLinkBridgeInitialized = true;

    const normalizePath = (path) => path.replace(/\/+$/, '') || '/';
    const cartUpdateEvent = 'shopify:cart:lines-update';
    const productMenuLinks = new Map([
      ['HUDVÅRD', 'belyr-brightening-serum'],
      ['HÅRVÅRD', 'belyr-keratin-hair-mask'],
      ['KROPPSVÅRD', 'belyr-firming-body-gel'],
      ['DEODORANT', 'belyr-mineral-roll-on'],
    ]);
    let scrollIndicatorFrame = 0;
    let observedCartDrawer = null;
    let cartDrawerObserver = null;
    let lastInteractionWasPointer = false;

    const clearCartReturnFocus = () => {
      if (!lastInteractionWasPointer) return;

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const activeElement = document.activeElement;
          if (!(activeElement instanceof HTMLElement)) return;

          if (
            activeElement.closest('.bh-product-card') ||
            activeElement.matches('.belyr-caia-header__icon--cart')
          ) {
            activeElement.blur();
          }
        });
      });
    };

    const syncCartScrollIndicator = () => {
      const content = document.querySelector('#cart-drawer .cart-drawer__content');
      const items = content?.querySelector('.cart-drawer__items');
      if (!content || !items) return;

      let indicator = content.querySelector(':scope > .belyr-cart-scroll-indicator');

      if (!indicator) {
        indicator = document.createElement('div');
        indicator.className = 'belyr-cart-scroll-indicator';
        indicator.hidden = true;
        indicator.setAttribute('aria-hidden', 'true');
        indicator.append(document.createElement('span'));
        content.append(indicator);
      }

      const trackHeight = items.clientHeight;
      const maximumScroll = items.scrollHeight - trackHeight;
      const shouldShow = trackHeight > 0 && maximumScroll > 2;
      indicator.hidden = !shouldShow;

      if (!shouldShow) return;

      const contentRect = content.getBoundingClientRect();
      const itemsRect = items.getBoundingClientRect();
      const thumb = indicator.firstElementChild;
      const thumbHeight = Math.min(
        trackHeight,
        Math.max(36, Math.round(trackHeight * (trackHeight / items.scrollHeight)))
      );
      const thumbTravel = Math.max(0, trackHeight - thumbHeight);
      const thumbOffset = maximumScroll > 0
        ? Math.round((items.scrollTop / maximumScroll) * thumbTravel)
        : 0;

      indicator.style.top = `${Math.round(itemsRect.top - contentRect.top)}px`;
      indicator.style.height = `${trackHeight}px`;
      thumb.style.height = `${thumbHeight}px`;
      thumb.style.transform = `translateY(${thumbOffset}px)`;
    };

    const scheduleCartScrollIndicator = () => {
      cancelAnimationFrame(scrollIndicatorFrame);
      scrollIndicatorFrame = requestAnimationFrame(() => {
        syncCartScrollIndicator();
        requestAnimationFrame(syncCartScrollIndicator);
      });
    };

    const observeCartDrawer = () => {
      const drawer = document.getElementById('cart-drawer');
      if (drawer === observedCartDrawer) return;

      cartDrawerObserver?.disconnect();
      observedCartDrawer = drawer;

      if (!drawer) return;

      cartDrawerObserver = new MutationObserver(scheduleCartScrollIndicator);
      cartDrawerObserver.observe(drawer, { childList: true, subtree: true });
    };

    const syncProductMenuLinks = () => {
      const root = window.Shopify?.routes?.root || '/';

      document.querySelectorAll('.belyr-caia-header__nav a').forEach((link) => {
        const handle = productMenuLinks.get(link.textContent.trim().toUpperCase());
        if (handle) link.href = `${root}products/${handle}`;
      });
    };

    const ensureCartCount = () => {
      const trigger = document.querySelector('.belyr-caia-header__icon--cart');
      if (!trigger) return null;

      let count = trigger.querySelector('.belyr-cart-count');

      if (!count) {
        count = document.createElement('span');
        count.className = 'belyr-cart-count';
        count.hidden = true;
        count.setAttribute('aria-hidden', 'true');
        trigger.append(count);
      }

      return { count, trigger };
    };

    const renderCartCount = (quantity) => {
      const elements = ensureCartCount();
      if (!elements || !Number.isFinite(quantity)) return;

      const itemCount = Math.max(0, Math.trunc(quantity));
      elements.count.textContent = itemCount > 99 ? '99+' : String(itemCount);
      elements.count.hidden = itemCount === 0;
      elements.trigger.setAttribute(
        'aria-label',
        itemCount === 1 ? 'Varukorg, 1 produkt' : `Varukorg, ${itemCount} produkter`
      );
    };

    const syncCartCount = async () => {
      const root = window.Shopify?.routes?.root || '/';

      try {
        const response = await fetch(`${root}cart.js`, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });

        if (!response.ok) return;

        const cart = await response.json();
        renderCartCount(Number(cart.item_count ?? cart.totalQuantity ?? 0));
      } catch (_) {
        // The next cart event or page view will retry the synchronization.
      }
    };

    document.addEventListener(cartUpdateEvent, (event) => {
      observeCartDrawer();
      scheduleCartScrollIndicator();

      if (!event.promise) {
        syncCartCount();
        return;
      }

      event.promise
        .then(({ cart }) => {
          const quantity = Number(cart?.totalQuantity ?? cart?.item_count);

          if (Number.isFinite(quantity)) {
            renderCartCount(quantity);
          } else {
            syncCartCount();
          }
        })
        .catch(() => {})
        .finally(scheduleCartScrollIndicator);
    });

    document.addEventListener(
      'scroll',
      (event) => {
        if (
          event.target instanceof Element &&
          event.target.matches('#cart-drawer .cart-drawer__items')
        ) {
          syncCartScrollIndicator();
        }
      },
      true
    );
    window.addEventListener('resize', scheduleCartScrollIndicator, { passive: true });
    document.addEventListener(
      'pointerdown',
      () => {
        lastInteractionWasPointer = true;
      },
      { capture: true, passive: true }
    );
    document.addEventListener(
      'keydown',
      () => {
        lastInteractionWasPointer = false;
      },
      true
    );
    document.addEventListener(
      'click',
      (event) => {
        if (!(event.target instanceof Element)) return;
        if (!lastInteractionWasPointer) return;

        const drawer = document.getElementById('cart-drawer');
        const dialog = drawer?.querySelector('dialog');
        const button = event.target.closest('#cart-drawer button');
        const closesDrawer =
          button?.classList.contains('theme-drawer__close-button') ||
          button?.getAttribute('on:click') === '#cart-drawer/close' ||
          event.target === dialog;

        if (!closesDrawer) return;
        window.setTimeout(clearCartReturnFocus, 420);
      },
      true
    );
    document.addEventListener(
      'close',
      (event) => {
        if (!(event.target instanceof HTMLDialogElement)) return;
        if (!event.target.closest('#cart-drawer')) return;
        clearCartReturnFocus();
      },
      true
    );
    window.addEventListener('pageshow', () => {
      syncCartCount();
      observeCartDrawer();
      scheduleCartScrollIndicator();
    });
    document.addEventListener('shopify:section:load', () => {
      syncProductMenuLinks();
      observeCartDrawer();
      scheduleCartScrollIndicator();
    });
    observeCartDrawer();
    scheduleCartScrollIndicator();
    syncProductMenuLinks();
    syncCartCount();

    document.addEventListener(
      'click',
      (event) => {
        if (
          event.defaultPrevented ||
          event.button !== 0 ||
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey ||
          !(event.target instanceof Element)
        ) {
          return;
        }

        const link = event.target.closest('a[href]');
        if (!link || link.target === '_blank' || link.hasAttribute('download')) return;

        const destination = new URL(link.href, window.location.href);
        if (destination.origin !== window.location.origin) return;

        const root = window.Shopify?.routes?.root || '/';
        const cartPath = normalizePath(`${root}cart`);
        const destinationPath = normalizePath(destination.pathname);
        const drawer = document.getElementById('cart-drawer');

        if (destinationPath === cartPath && drawer) {
          event.preventDefault();

          if (window.Shopify?.actions?.openCart) {
            window.Shopify.actions.openCart();
          } else if (typeof drawer.open === 'function') {
            drawer.open();
          }

          scheduleCartScrollIndicator();

          return;
        }

        const themeRole = String(window.Shopify?.theme?.role || '').toLowerCase();
        const themeId = window.Shopify?.theme?.id;

        if (
          themeRole &&
          themeRole !== 'main' &&
          themeId &&
          !destination.searchParams.has('preview_theme_id')
        ) {
          event.preventDefault();
          destination.searchParams.set('preview_theme_id', themeId);
          window.location.assign(destination.toString());
        }
      },
      true
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
